import { root } from './avg-watch-time';

export const avgWatchTime = {
  ...root,
};
